import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from './FormCheckbox.scss'

import FormLabel from '../Label'

export const FormCheckbox = (props) => {
  let className = { [classes['checkbox']]: classes['checkbox'] }
  props.options.forEach((option) => {
    className[classes[`checkbox--${option}`]] = classes[`checkbox--${option}`]
  })
  className = cx(className)

  return (
    <FormLabel {...props}>
      <input
        className={className}
        value={!!props.value}

        {...props.input}
        onChange={props.onChange && ::props.onChange}

        checked={!!props.value}
        type='checkbox'
      />
    </FormLabel>
  )
}

FormCheckbox.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  input: PropTypes.shape({}),
}

FormCheckbox.defaultProps = {
  options: []
}

export default FormCheckbox



// WEBPACK FOOTER //
// ./src/components/Form/Checkbox/FormCheckbox.js